import { AppRouteProps } from "@bsm/component";
import { ScholarityCreateContainer } from "./container/ScholarityCreateContainer";

export const ScholarityCreateRoute = [
    {
        path: "-1",
        element: <ScholarityCreateContainer />
    },
] as Array<AppRouteProps>